import { createReducer } from '@reduxjs/toolkit'
import { setMainWidth } from '../actions'

const initialState = 0

export const mainWidth = createReducer(initialState, {
  [setMainWidth.type]: (state, action) => action.payload
})
